import ClusterStat from 'components/OverviewCard/ClusterStat';
import Picture from 'components/Picture';
import { PlaceholderText } from 'components/Placeholders';
import { SectionCard } from 'components/SectionCard';
import SelectableScoreCardMetric from './SelectableScoreCardMetric';
import ToggleWatch from 'components/Button/ToggleWatch';
import { applySentenceCase, formatVolume } from 'utils/helpers';
import { views } from '@/copy';

const { categorySummary, categoryThree } = views;

/**
 * The cat2-4 hero: name, the score card, the ranking sentence, and the category
 * image.
 */
function CategoryScoreCardHero({
    categoryId,
    name,
    image,
    isLoading,
    volumeLabel,
    volume,
    metricsList,
    defaultMetric,
    metrics,
    attributionProps,
    cluster,
    summaryReady,
    summaryTerms,
}) {
    return (
        <SectionCard
            // `!`: styled-components loads after Tailwind and wins any tie.
            className="!pt-5"
        >
            <div className="grid grid-cols-[1fr_50%] gap-x-6 min-h-[260px] items-stretch">
                <div className="flex flex-col gap-5 self-center">
                    <div className="flex flex-row items-center justify-start">
                        <h1 className="text-2xl font-bold capitalize m-0">
                            {name}
                        </h1>
                        <ToggleWatch
                            id={categoryId}
                            data={{ name, type: 'category' }}
                        />
                    </div>
                    <dl className="flex items-stretch gap-8 [&>div]:flex [&>div]:flex-col [&>div]:gap-2 [&_dt]:order-2 [&_dt]:m-0 [&_dt]:uppercase [&_dt]:text-xs [&_dt]:font-semibold [&_dt]:text-neutral-800 [&_dd]:order-1 [&_dd]:m-0 [&_dd]:flex [&_dd]:grow [&_dd]:items-end [&_dd]:uppercase [&_dd]:text-2xl [&_dd]:font-bold [&_dd]:text-black">
                        <div>
                            <dt>{volumeLabel}</dt>
                            <dd>
                                {isLoading ? (
                                    <PlaceholderText width="1em" />
                                ) : (
                                    formatVolume(volume)
                                )}
                            </dd>
                        </div>

                        <SelectableScoreCardMetric
                            metrics={metrics}
                            metricsList={metricsList}
                            defaultMetric={defaultMetric}
                            isLoading={isLoading}
                            tikTokSourceAttributionProps={attributionProps}
                        />

                        <div>
                            <dt>{categorySummary.scoreCardClusterText}</dt>
                            <dd>
                                {isLoading ? (
                                    <PlaceholderText width="1.5em" />
                                ) : (
                                    <ClusterStat
                                        showIcon={false}
                                        // `!`: styled-components, as above.
                                        className="![font-size:inherit] ![line-height:inherit] capitalize !font-bold"
                                        cluster={cluster}
                                    />
                                )}
                            </dd>
                        </div>
                    </dl>
                    {summaryReady ? (
                        <p className="m-0 font-normal leading-[1.7em] text-muted-foreground">
                            {applySentenceCase(
                                categoryThree.categoryDescription(summaryTerms),
                            )}
                        </p>
                    ) : (
                        <PlaceholderText lines={4} />
                    )}
                </div>
                <div className="rounded-[3px] overflow-hidden flex">
                    <Picture src={image ? image[0] : null} alt="" />
                </div>
            </div>
        </SectionCard>
    );
}

export default CategoryScoreCardHero;
